import SelectDefaultCurrency from './select-default-currency';

export default SelectDefaultCurrency;
